export const RICH_TEXT_IMAGE_COLLECTION = "page_metafield_richtext_images";

export interface RichTextImageUploadResult {
  id: string;
  url?: string;
  cdn_url?: string;
}

export interface RichTextImageEmbedResult {
  url: string;
  mediaId: string;
}

export type RichTextImageUploadFn = (
  file: File,
  collection: string,
  metadata?: object
) => Promise<RichTextImageUploadResult>;

export async function uploadRichTextImage(
  uploadFn: RichTextImageUploadFn,
  file: File
): Promise<RichTextImageEmbedResult> {
  const result = await uploadFn(file, RICH_TEXT_IMAGE_COLLECTION);
  const url = result.cdn_url || result.url;

  if (!url) {
    throw new Error("Rich text image upload did not return a URL.");
  }

  return {
    url,
    mediaId: result.id,
  };
}
